import { useState, MouseEvent } from 'react';
import Loading from '@/component/mui/Backdrop';
import { FactoryType } from '@/types';
import { Box, Button } from '@mui/material';
import FactorySettingForm from '@/component/factory-setting/FactorySettingForm';
import { createFactory } from '@/api/asset/factory/create';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function CreateFactory() {
  const [factory, setFactory] = useState<FactoryType>({
    adminAddress: '',
    contractAddr: '',
    network: '137',
    description: '',
    title: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const onSubmit = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true);
    await handleContract();
  };

  const handleContract = async () => {
    try {
      const re = await createFactory(factory);
      console.log(re);
      toast.success('성공');
      navigate('/factory-list');
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          overflow: 'auto',
          flex: 1,
          flexDirection: 'column',
          gap: { xs: '16px', sm: '0px' },
        }}
      >
        <FactorySettingForm
          factory={factory}
          setFactory={setFactory}
          title="컨트랙트 풀 생성 아직, DB처리만 가능함"
          type="create"
        />
        <Button variant="contained" onClick={onSubmit}>
          Create
        </Button>
      </Box>
      <Loading isLoading={isLoading} />
    </>
  );
}
